module.exports = __webpack_public_path__ + "media/components/country-flag/static/gm-bf4dfa97f65928faf6782fe462bdeea1.svg";